import {z} from 'zod';

import {isNil} from 'ramda';

import i18n from '@dms/i18n';

const baseSchema = z.object({
  damageCode: z.string().max(7).nonempty().nullish(),
  isPartClaimDamage: z.boolean(),
  installationDate: z.date().nullish(),
  installationMileage: z.number().min(0).nullish(),
  replacedByDealer: z.string().nullish(),
  replacedPartNumber: z.string().nullish(),
});

export const EvaClaimAdditionalInformationFormSchema = baseSchema.superRefine((data, ctx) => {
  if (data.isPartClaimDamage) {
    const requiredMessage = i18n.t('general.validations.fieldIsRequired');

    if (isNil(data.installationDate)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['installationDate'],
        message: requiredMessage,
      });
    }

    if (isNil(data.installationMileage)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['installationMileage'],
        message: requiredMessage,
      });
    }

    if (isNil(data.replacedByDealer)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['replacedByDealer'],
        message: requiredMessage,
      });
    }

    if (isNil(data.replacedPartNumber)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['replacedPartNumber'],
        message: requiredMessage,
      });
    }
  }
});

export type EvaClaimAdditionalInformationFormType = z.infer<typeof baseSchema>;
